export default __webpack_public_path__ + "static/media/coin-light.bfc48262.svg";